import { pluralize } from '@cian/newbuilding-utils';

export const getText = ({ quantity }: { quantity: number }): string => {
  return `${pluralize(quantity, ['квартира', 'квартиры', 'квартир'])} куплено на этой неделе. `;
};
